import {
  getAll,
  getPage,
  getDetail,
  addObj,
  modifyObj,
  deleteObj,
  uploadInstallorderePicture,
} from '@/api/rmfreeserv'

export default {
  state: {
    state_RmFree_GetAllResult: null,
    state_RmFree_GetPageResult: null,
    state_RmFree_GetDetailResult: null,
    state_RmFree_AddObjResult: null,
    state_RmFree_ModifyObjResult: null,
    state_RmFree_DeleteObjResult: null,
    state_RmFree_UploadInstallorderePictureResult: null,
  },
  mutations: {
    SET_RMFREE_GETALL_RESULT: (state, rst) => {
      state.state_RmFree_GetAllResult = rst;
    },
    SET_RMFREE_GETPAGE_RESULT: (state, rst) => {
      state.state_RmFree_GetPageResult = rst;
    },
    SET_RMFREE_GETDETAIL_RESULT: (state, rst) => {
      state.state_RmFree_GetDetailResult = rst;
    },
    SET_RMFREE_ADDOBJ_RESULT: (state, rst) => {
      state.state_RmFree_AddObjResult = rst;
    },
    SET_RMFREE_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_RmFree_ModifyObjResult = rst;
    },
    SET_RMFREE_DELETEOBJ_RESULT: (state, rst) => {
      state.state_RmFree_DeleteObjResult = rst;
    },
    SET_RMFREE_UPLOADINSTALLORDEREPICTURE_RESULT: (state, rst) => {
      state.state_RmFree_UploadInstallorderePictureResult = rst;
    },
  },
  actions: {
    RmFreeServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RMFREE_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RMFREE_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RmFreeServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RMFREE_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RMFREE_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RmFreeServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RMFREE_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RMFREE_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RmFreeServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RMFREE_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RMFREE_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RmFreeServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RMFREE_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RMFREE_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RmFreeServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RMFREE_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RMFREE_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RmFreeServ_UploadInstallorderePicture({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        uploadInstallorderePicture(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RMFREE_UPLOADINSTALLORDEREPICTURE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RMFREE_UPLOADINSTALLORDEREPICTURE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_RmFree_GetAllResult: state => {
      return state.state_RmFree_GetAllResult;
    },
    get_RmFree_GetPageResult: state => {
      return state.state_RmFree_GetPageResult;
    },
    get_RmFree_GetDetailResult: state => {
      return state.state_RmFree_GetDetailResult;
    },
    get_RmFree_AddObjResult: state => {
      return state.state_RmFree_AddObjResult;
    },
    get_RmFree_ModifyObjResult: state => {
      return state.state_RmFree_ModifyObjResult;
    },
    get_RmFree_DeleteObjResult: state => {
      return state.state_RmFree_DeleteObjResult;
    },
    get_RmFree_UploadInstallorderePictureResult: state => {
      return state.state_RmFree_UploadInstallorderePictureResult;
    },
  }
}